import React from 'react';
import PropTypes from 'prop-types';


class ReferralProgramDetails extends React.Component {
  componentDidMount() {
    window.growsurf.init();
  }

  render() {
    return (
      <React.Fragment>
        <div className="cs-referral-program-page-content__section">
          <h2 className="cs-referral-program-page-content__title">Share your unique referral link</h2>
          <div data-grsf-block-form data-grsf-email={this.props.referralId}></div>
        </div>

        <div className="cs-referral-program-page-content__section">
          <h2 className="cs-referral-program-page-content__title">Your credits</h2>
          <div data-grsf-block-referral-status data-grsf-email={this.props.referralId}></div>
        </div>
      </React.Fragment>
    );
  }
}


ReferralProgramDetails.propTypes = {
  referralId: PropTypes.string
};


export default ReferralProgramDetails;

